import React from 'react';

export function FyrstaSaeti() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="112"
      height="112"
      viewBox="0 0 112 112"
    >
      <g
        id="Ársskýrsla/icon/FyrstaSæti"
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      >
        <g
          id="gaming-trophy-check"
          stroke="#163E63"
          strokeWidth="2"
          transform="translate(20 20)"
        >
          <path
            id="Path"
            d="M47.7484337 9.79644578L33.1550602 28.2301807 25.4743373 20.5494578"
          ></path>
          <path
            id="Path"
            d="M8.697 41.386a12.29 12.29 0 01-8.028-11.53v-7.681a3.072 3.072 0 013.072-3.073h6.301M63.303 41.386a12.29 12.29 0 008.028-11.53v-7.681a3.072 3.072 0 00-3.072-3.073h-6.301"
          ></path>
          <path
            id="Path"
            d="M63.595 3.818a3.072 3.072 0 00-3.072-3.15H11.477a3.073 3.073 0 00-3.072 3.15C9.47 47.488 32.839 35.01 32.839 51.36c-.17 9.47-4.096 12.98-10.824 13.687a3.229 3.229 0 00-2.894 3.211 3.072 3.072 0 003.072 3.072h27.614a3.072 3.072 0 003.072-3.072c0-1.653-1.25-3.039-2.894-3.21-6.728-.707-10.655-4.219-10.824-13.688 0-16.35 23.368-3.874 24.434-47.543z"
          ></path>
        </g>
      </g>
    </svg>
  );
}
